import { render, staticRenderFns } from "./Coleta.vue?vue&type=template&id=0e330fa6&"
import script from "./Coleta.vue?vue&type=script&lang=js&"
export * from "./Coleta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports